import { useAuthActions, useAuthContext } from "@contexts/auth";
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { trackPageView } from "@utils/activityTracker";

// Espera a rota "assentar" antes de registrar o acesso: os redirecionamentos automáticos
// (ex.: /dashboard/curva -> /dashboard/curva/<obra>) não viram acessos duplicados.
const PAGE_VIEW_SETTLE_MS = 800;

const AppContainer = () => {
  const { user, cookieChecked } = useAuthContext();
  const { checkAuth } = useAuthActions();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (cookieChecked) {
      if (pathname.includes('registerForm') || pathname.includes('clientForm')) return
      if (!user && !pathname.includes("/access")) {
        navigate("/access")
      } else if (user && !pathname.includes("/dashboard")) {
        if (user.roles.includes("bim")) navigate("/dashboard/bim/cadastro");
        if (user.roles.includes("costs")) navigate("/dashboard/costs/obras");
        if (user.roles.includes("ampli") || user.roles.includes("admin")) navigate("/dashboard")
      }
    }
  }, [user, cookieChecked])

  useEffect(() => {
    if (!user?._id || !pathname.startsWith("/dashboard")) return undefined;
    const timeout = setTimeout(() => trackPageView(pathname), PAGE_VIEW_SETTLE_MS);
    return () => clearTimeout(timeout);
  }, [pathname, user?._id])

  return <Outlet />
}

export default AppContainer;